import headerLogo from "../assets/images/header-logo.png";

export const headerData = {
      title: 'Header - US',
      logo: {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'n9bebhw263o0'
            }
          },
          id: '5AKPoUN7gpAPK5qSmfp2Fx',
          type: 'Asset',
          createdAt: '2022-10-26T21:37:55.474Z',
          updatedAt: '2022-10-26T21:37:55.474Z',
          environment: {
            sys: {
              id: 'master',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          publishedVersion: 6,
          revision: 1,
          locale: 'en-US'
        },
        fields: {
          title: 'Moderna Logo - Transparent',
          description: '',
          file: {
            url: headerLogo,
            details: {
              size: 11690,
              image: {
                width: 541,
                height: 121
              }
            },
            fileName: 'logo.png',
            contentType: 'image/png'
          }
        }
      },
      navigationItems: [
        {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
              }
            },
            id: '5X3uyXLesGZj35QP97uTMP',
            type: 'Entry',
            createdAt: '2021-12-08T18:29:04.756Z',
            updatedAt: '2023-06-01T05:21:29.355Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 15,
            revision: 6,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'navigationItem'
              }
            },
            locale: 'en-US'
          },
          fields: {
            title: 'Products',
            label: 'Products',
            link: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                  }
                },
                id: '45nuNfadDYJFKSaiYoFq63',
                type: 'Entry',
                createdAt: '2021-12-09T23:39:01.226Z',
                updatedAt: '2023-06-06T13:31:16.623Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'internalLink'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Products Link',
                label: 'Shop',
                pageReference: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                      }
                    },
                    id: '2IDXH1eeS3uolefmMF0fSF',
                    type: 'Entry',
                    createdAt: '2023-06-05T22:01:10.998Z',
                    updatedAt: '2024-07-15T23:35:47.323Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    publishedVersion: 9,
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'page'
                      }
                    },
                    locale: 'en-US'
                  },
                  fields: {
                    name: 'Category Landing Page',
                    title: 'Products',
                    slug: 'order-form',
                    seo: {
                      metadata: {
                        tags: [],
                        concepts: []
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                          }
                        },
                        id: '7DvUzBlYbnNYYiEDOMTFWP',
                        type: 'Entry',
                        createdAt: '2023-06-05T22:01:11.546Z',
                        updatedAt: '2023-06-05T22:01:11.546Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment'
                          }
                        },
                        publishedVersion: 4,
                        revision: 1,
                        contentType: {
                          sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'seo'
                          }
                        },
                        locale: 'en-US'
                      },
                      fields: {
                        name: 'Category Landing Page - Compose: SEO'
                      }
                    },
                    content: {
                      metadata: {
                        tags: [],
                        concepts: []
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                          }
                        },
                        id: '5uiGQIBBQR4HaehQd3qB9L',
                        type: 'Entry',
                        createdAt: '2023-06-05T22:01:11.623Z',
                        updatedAt: '2023-09-07T20:51:21.016Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment'
                          }
                        },
                        publishedVersion: 14,
                        revision: 4,
                        contentType: {
                          sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'categoryLandingPageTemplate'
                          }
                        },
                        locale: 'en-US'
                      },
                      fields: {
                        name: 'Category Landing Page - Category Landing Page Template',
                        modules: [
                          {
                            metadata: {
                              tags: [],
                              concepts: []
                            },
                            sys: {
                              space: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'Space',
                                  id: 'n9bebhw263o0'
                                }
                              },
                              id: '3lrvHdNg9iyh7Sd9q8I8SJ',
                              type: 'Entry',
                              createdAt: '2023-06-05T21:52:31.144Z',
                              updatedAt: '2023-09-07T21:06:56.918Z',
                              environment: {
                                sys: {
                                  id: 'master',
                                  type: 'Link',
                                  linkType: 'Environment'
                                }
                              },
                              publishedVersion: 14,
                              revision: 4,
                              contentType: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'ContentType',
                                  id: 'categoryProductTilesComponent'
                                }
                              },
                              locale: 'en-US'
                            },
                            fields: {
                              title: 'COVID-19 Vaccine Product Tiles Component',
                              commerceCategoryId: 'covid19Boosters',
                              productImagePlaceholder: {
                                metadata: {
                                  tags: [],
                                  concepts: []
                                },
                                sys: {
                                  space: {
                                    sys: {
                                      type: 'Link',
                                      linkType: 'Space',
                                      id: 'n9bebhw263o0'
                                    }
                                  },
                                  id: '4vXEuLzH5I48N8ikqlzo1a',
                                  type: 'Asset',
                                  createdAt: '2023-07-18T21:05:38.124Z',
                                  updatedAt: '2023-07-18T21:05:38.124Z',
                                  environment: {
                                    sys: {
                                      id: 'master',
                                      type: 'Link',
                                      linkType: 'Environment'
                                    }
                                  },
                                  publishedVersion: 8,
                                  revision: 1,
                                  locale: 'en-US'
                                },
                                fields: {
                                  title: 'Product image unavailable 397x397',
                                  file: {
                                    url: '//images.ctfassets.net/n9bebhw263o0/4vXEuLzH5I48N8ikqlzo1a/515a812a677106b89e599ed4903c45b9/product-image-unavailable.png',
                                    details: {
                                      size: 14666,
                                      image: {
                                        width: 396,
                                        height: 397
                                      }
                                    },
                                    fileName: 'product-image-unavailable.png',
                                    contentType: 'image/png'
                                  }
                                }
                              }
                            }
                          },
                          {
                            metadata: {
                              tags: [],
                              concepts: []
                            },
                            sys: {
                              space: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'Space',
                                  id: 'n9bebhw263o0'
                                }
                              },
                              id: '1Ppy7GvsqeBmi4Kvy5HHgn',
                              type: 'Entry',
                              createdAt: '2023-06-05T21:34:48.717Z',
                              updatedAt: '2023-09-11T17:41:01.029Z',
                              environment: {
                                sys: {
                                  id: 'master',
                                  type: 'Link',
                                  linkType: 'Environment'
                                }
                              },
                              publishedVersion: 69,
                              revision: 17,
                              contentType: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'ContentType',
                                  id: 'categoryHeroBannerComponent'
                                }
                              },
                              locale: 'en-US'
                            },
                            fields: {
                              title: 'COVID-19 Vaccine Category Banner',
                              headline: 'COVID-19 Vaccine, mRNA 2023-2024 Formula',
                              message: {
                                data: {},
                                content: [
                                  {
                                    data: {},
                                    content: [
                                      {
                                        data: {},
                                        marks: [],
                                        value: 'Scroll down to make your product selection.',
                                        nodeType: 'text'
                                      }
                                    ],
                                    nodeType: 'paragraph'
                                  }
                                ],
                                nodeType: 'document'
                              },
                              backgroundImage: {
                                metadata: {
                                  tags: [],
                                  concepts: []
                                },
                                sys: {
                                  space: {
                                    sys: {
                                      type: 'Link',
                                      linkType: 'Space',
                                      id: 'n9bebhw263o0'
                                    }
                                  },
                                  id: '1tQWkkMWPtATssCwU912QD',
                                  type: 'Asset',
                                  createdAt: '2023-06-06T16:16:57.031Z',
                                  updatedAt: '2023-07-28T17:19:35.133Z',
                                  environment: {
                                    sys: {
                                      id: 'master',
                                      type: 'Link',
                                      linkType: 'Environment'
                                    }
                                  },
                                  publishedVersion: 12,
                                  revision: 3,
                                  locale: 'en-US'
                                },
                                fields: {
                                  title: 'CLP Banner Background',
                                  description: '',
                                  file: {
                                    url: '//images.ctfassets.net/n9bebhw263o0/1tQWkkMWPtATssCwU912QD/f713f6f568b90e1566168ef5bb76cf46/CLP_BG_VIAL_SYRINGE.png',
                                    details: {
                                      size: 18363,
                                      image: {
                                        width: 1920,
                                        height: 660
                                      }
                                    },
                                    fileName: 'CLP_BG_VIAL_SYRINGE.png',
                                    contentType: 'image/png'
                                  }
                                }
                              },
                              mobileBackgroundImage: {
                                metadata: {
                                  tags: [],
                                  concepts: []
                                },
                                sys: {
                                  space: {
                                    sys: {
                                      type: 'Link',
                                      linkType: 'Space',
                                      id: 'n9bebhw263o0'
                                    }
                                  },
                                  id: '1rtVdADg6a3LlxoS530wiW',
                                  type: 'Asset',
                                  createdAt: '2023-06-07T15:26:07.005Z',
                                  updatedAt: '2023-07-28T17:19:51.239Z',
                                  environment: {
                                    sys: {
                                      id: 'master',
                                      type: 'Link',
                                      linkType: 'Environment'
                                    }
                                  },
                                  publishedVersion: 7,
                                  revision: 2,
                                  locale: 'en-US'
                                },
                                fields: {
                                  title: 'CLP BG2 Vial Mobile-min',
                                  description: '',
                                  file: {
                                    url: '//images.ctfassets.net/n9bebhw263o0/1rtVdADg6a3LlxoS530wiW/0119aaf622c1bca557c8ea58153ce673/CLP_BG_VIAL_SYRINGE_MOBILE.png',
                                    details: {
                                      size: 9097,
                                      image: {
                                        width: 390,
                                        height: 818
                                      }
                                    },
                                    fileName: 'CLP_BG_VIAL_SYRINGE_MOBILE.png',
                                    contentType: 'image/png'
                                  }
                                }
                              },
                              country: {
                                metadata: {
                                  tags: [],
                                  concepts: []
                                },
                                sys: {
                                  space: {
                                    sys: {
                                      type: 'Link',
                                      linkType: 'Space',
                                      id: 'n9bebhw263o0'
                                    }
                                  },
                                  id: '7sht7920U6vs3CLH2CUyaa',
                                  type: 'Entry',
                                  createdAt: '2023-05-18T03:23:50.744Z',
                                  updatedAt: '2023-05-24T22:55:23.250Z',
                                  environment: {
                                    sys: {
                                      id: 'master',
                                      type: 'Link',
                                      linkType: 'Environment'
                                    }
                                  },
                                  publishedVersion: 6,
                                  revision: 2,
                                  contentType: {
                                    sys: {
                                      type: 'Link',
                                      linkType: 'ContentType',
                                      id: 'country'
                                    }
                                  },
                                  locale: 'en-US'
                                },
                                fields: {
                                  name: 'United States',
                                  isocode: 'US',
                                  flag: {
                                    metadata: {
                                      tags: [],
                                      concepts: []
                                    },
                                    sys: {
                                      space: {
                                        sys: {
                                          type: 'Link',
                                          linkType: 'Space',
                                          id: 'n9bebhw263o0'
                                        }
                                      },
                                      id: '3aYCbZJiL8aoEKRdhjOXyy',
                                      type: 'Asset',
                                      createdAt: '2023-05-24T22:54:50.939Z',
                                      updatedAt: '2023-05-24T22:54:50.939Z',
                                      environment: {
                                        sys: {
                                          id: 'master',
                                          type: 'Link',
                                          linkType: 'Environment'
                                        }
                                      },
                                      publishedVersion: 5,
                                      revision: 1,
                                      locale: 'en-US'
                                    },
                                    fields: {
                                      title: 'usa flag',
                                      description: 'USA Flag',
                                      file: {
                                        url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                        details: {
                                          size: 2487,
                                          image: {
                                            width: 36,
                                            height: 26
                                          }
                                        },
                                        fileName: 'usa_flag.svg',
                                        contentType: 'image/svg+xml'
                                      }
                                    }
                                  },
                                  locales: [
                                    'en-US'
                                  ]
                                }
                              }
                            }
                          },
                          {
                            metadata: {
                              tags: [],
                              concepts: []
                            },
                            sys: {
                              space: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'Space',
                                  id: 'n9bebhw263o0'
                                }
                              },
                              id: '4IptIiVqzfkBRBOp8NPHDZ',
                              type: 'Entry',
                              createdAt: '2023-06-05T22:24:17.726Z',
                              updatedAt: '2023-09-11T20:52:23.128Z',
                              environment: {
                                sys: {
                                  id: 'master',
                                  type: 'Link',
                                  linkType: 'Environment'
                                }
                              },
                              publishedVersion: 23,
                              revision: 6,
                              contentType: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'ContentType',
                                  id: 'categoryEducationalCardsComponent'
                                }
                              },
                              locale: 'en-US'
                            },
                            fields: {
                              title: 'COVID-19 Vaccine Category Educational Cards Component',
                              headline: 'Dosage and Administration',
                              subheadline: '(For intramuscular injection only)',
                              cards: [
                                {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Entry',
                                    id: '7lPQBTQXzQaEt6nQNGwU4Z'
                                  }
                                },
                                {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Entry',
                                    id: 'hEvHJ3N6UOH3ueuvtWbKw'
                                  }
                                },
                                {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Entry',
                                    id: 'WpRN6qcUfwCg8HdXl8WWu'
                                  }
                                },
                                {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Entry',
                                    id: '1WbTwu4WfBg5xPwq6ptLXc'
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  }
                }
              }
            },
            commerce: true
          }
        },
        {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
              }
            },
            id: '1AezMjnGahTY4DcaGulahM',
            type: 'Entry',
            createdAt: '2023-05-22T13:52:22.468Z',
            updatedAt: '2023-06-01T05:48:30.363Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 3,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'navigationItem'
              }
            },
            locale: 'en-US'
          },
          fields: {
            title: 'Order History',
            label: 'Order History',
            link: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                  }
                },
                id: '6xl3DTzE5hx9q2C0p9PvXf',
                type: 'Entry',
                createdAt: '2023-06-01T05:48:25.029Z',
                updatedAt: '2023-06-01T05:48:25.029Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'internalLink'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Order History Internal Link',
                label: 'Order History',
                pageReference: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                      }
                    },
                    id: '4OLIozTDIHZZsTo1s7pjYj',
                    type: 'Entry',
                    createdAt: '2023-05-30T16:59:41.945Z',
                    updatedAt: '2023-06-01T05:48:19.579Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    publishedVersion: 11,
                    revision: 2,
                    contentType: {
                      sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'page'
                      }
                    },
                    locale: 'en-US'
                  },
                  fields: {
                    name: 'Order History Page',
                    title: 'Order History',
                    slug: 'orders',
                    seo: {
                      metadata: {
                        tags: [],
                        concepts: []
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                          }
                        },
                        id: '3XGtPu5vNnA1Dl3bL5Yp2S',
                        type: 'Entry',
                        createdAt: '2023-05-30T16:59:42.078Z',
                        updatedAt: '2023-05-30T16:59:42.078Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment'
                          }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                          sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'seo'
                          }
                        },
                        locale: 'en-US'
                      },
                      fields: {
                        name: 'Order History Page - Compose: SEO'
                      }
                    },
                    content: {
                      metadata: {
                        tags: [],
                        concepts: []
                      },
                      sys: {
                        space: {
                          sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                          }
                        },
                        id: '7KOCN0WVlOyMtC9QrWxhh9',
                        type: 'Entry',
                        createdAt: '2023-05-30T16:59:42.164Z',
                        updatedAt: '2024-01-31T23:05:22.234Z',
                        environment: {
                          sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment'
                          }
                        },
                        publishedVersion: 13,
                        revision: 6,
                        contentType: {
                          sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'orderHistoryPageTempalte'
                          }
                        },
                        locale: 'en-US'
                      },
                      fields: {
                        name: 'Order History Page - Order History Page Tempalte',
                        modules: [
                          {
                            metadata: {
                              tags: [],
                              concepts: []
                            },
                            sys: {
                              space: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'Space',
                                  id: 'n9bebhw263o0'
                                }
                              },
                              id: '67Cgp0ms6SZIQsWBrKb6LD',
                              type: 'Entry',
                              createdAt: '2023-06-30T04:15:43.114Z',
                              updatedAt: '2023-07-31T18:07:27.558Z',
                              environment: {
                                sys: {
                                  id: 'master',
                                  type: 'Link',
                                  linkType: 'Environment'
                                }
                              },
                              publishedVersion: 22,
                              revision: 5,
                              contentType: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'ContentType',
                                  id: 'orderHIstoryBannerComponent'
                                }
                              },
                              locale: 'en-US'
                            },
                            fields: {
                              title: 'Order History Banner Component',
                              headline: 'Order History',
                              backgroundImage: {
                                metadata: {
                                  tags: [],
                                  concepts: []
                                },
                                sys: {
                                  space: {
                                    sys: {
                                      type: 'Link',
                                      linkType: 'Space',
                                      id: 'n9bebhw263o0'
                                    }
                                  },
                                  id: '5zfGJA7or5WGcLdYi4Qde',
                                  type: 'Asset',
                                  createdAt: '2022-10-28T18:53:29.208Z',
                                  updatedAt: '2022-10-28T18:53:29.208Z',
                                  environment: {
                                    sys: {
                                      id: 'master',
                                      type: 'Link',
                                      linkType: 'Environment'
                                    }
                                  },
                                  publishedVersion: 6,
                                  revision: 1,
                                  locale: 'en-US'
                                },
                                fields: {
                                  title: 'Banner BG Strand Top',
                                  description: '',
                                  file: {
                                    url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                    details: {
                                      size: 47693,
                                      image: {
                                        width: 1920,
                                        height: 511
                                      }
                                    },
                                    fileName: 'Banner BG Strand Top .png',
                                    contentType: 'image/png'
                                  }
                                }
                              },
                              orderStatusLabel: [
                                'PENDING',
                                'DELIVERED'
                              ],
                              totalOrdersLabel: 'TOTAL ORDERS',
                              totalOrdersDropdownOptions: [
                                'Last 30 Days',
                                'Last 60 Days',
                                'Last 90 Days',
                                'Last Year'
                              ],
                              orderHistoryCardOrdersLabel: 'Orders',
                              orderHistoryCardSinceLabel: 'Since'
                            }
                          },
                          {
                            metadata: {
                              tags: [],
                              concepts: []
                            },
                            sys: {
                              space: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'Space',
                                  id: 'n9bebhw263o0'
                                }
                              },
                              id: 'aGMNjo382dbe0mWwl0j73',
                              type: 'Entry',
                              createdAt: '2023-06-30T04:07:27.031Z',
                              updatedAt: '2024-05-24T01:05:09.960Z',
                              environment: {
                                sys: {
                                  id: 'master',
                                  type: 'Link',
                                  linkType: 'Environment'
                                }
                              },
                              publishedVersion: 71,
                              revision: 22,
                              contentType: {
                                sys: {
                                  type: 'Link',
                                  linkType: 'ContentType',
                                  id: 'orderHIstoryTableComponent'
                                }
                              },
                              locale: 'en-US'
                            },
                            fields: {
                              title: 'Order History Table Component',
                              headerLabel: 'Orders',
                              modernaIdColumnLabel: 'MODERNA ORDER ID',
                              referenceIdColumnLabel: 'MCKESSON(RXC) SHIPPING ID',
                              subtotalColumnLabel: 'SUBTOTAL AMOUNT',
                              poNumberColumnLabel: 'PO Number',
                              datePlacedColumnLabel: 'DATE PLACED',
                              deliveryLocationColumnLabel: 'DELIVERY LOCATION',
                              orderStatusColumnLabel: 'STATUS',
                              totalOrdersLabel: 'TOTAL ORDERS',
                              pendingStatusLabel: 'Pending',
                              deliveredStatusLabel: 'Delivered',
                              ordersText: 'Orders',
                              disclaimerMessageBody: 'Selected shipping dates are subject to change depending on product availability. We will notify you of any changes.',
                              disclaimerMessage: {
                                data: {},
                                content: [
                                  {
                                    data: {},
                                    content: [
                                      {
                                        data: {},
                                        marks: [],
                                        value: 'Pricing is subject to change. For contracted customers, contract price will be reflected at time of invoicing. For questions about pricing, contact your Moderna Account Manager or Moderna customer service.',
                                        nodeType: 'text'
                                      }
                                    ],
                                    nodeType: 'paragraph'
                                  }
                                ],
                                nodeType: 'document'
                              },
                              actionLabel: 'ACTIONS',
                              reservationTitle: 'Reservations'
                            }
                          }
                        ]
                      }
                    }
                  }
                }
              }
            },
            commerce: true
          }
        }
      ],
      country: {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'n9bebhw263o0'
            }
          },
          id: '7sht7920U6vs3CLH2CUyaa',
          type: 'Entry',
          createdAt: '2023-05-18T03:23:50.744Z',
          updatedAt: '2023-05-24T22:55:23.250Z',
          environment: {
            sys: {
              id: 'master',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          publishedVersion: 6,
          revision: 2,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'country'
            }
          },
          locale: 'en-US'
        },
        fields: {
          name: 'United States',
          isocode: 'US',
          flag: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'n9bebhw263o0'
                }
              },
              id: '3aYCbZJiL8aoEKRdhjOXyy',
              type: 'Asset',
              createdAt: '2023-05-24T22:54:50.939Z',
              updatedAt: '2023-05-24T22:54:50.939Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              publishedVersion: 5,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'usa flag',
              description: 'USA Flag',
              file: {
                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                details: {
                  size: 2487,
                  image: {
                    width: 36,
                    height: 26
                  }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
              }
            }
          },
          locales: [
            'en-US'
          ]
        }
      }
}